import { ClientBusinessModel } from 'app/client/clientBusiness/models/ClientBusiness';
import { RateModel } from 'app/client/clientBusiness/rates/models/RateModel';
import {
  ViajeTrasladoCreateModelLegacyDontUse,
  ViajeTrasladoModelLegacyDontUse,
  ViajeTrasladoTipoServicio
} from 'app/viaje/models';
import { Moment } from 'moment';
import {
  transferReservationBaseFormBuilder,
  TransferReservationBaseFormType,
  transferReservationBaseLocationFormBuilder,
  TransferReservationBaseLocationFormType
} from '../base/TransferReservationBaseFormTypes';
import { AirportDetails } from '../../models/TransferReservationPartial';

export interface TransferReservationSingleFormType
  extends TransferReservationBaseFormType {
  fechaYHoraDeLlegada: Moment;
  minutosPreviosASalida: Moment;
  puntos: TransferReservationBaseLocationFormType[];
  reason_reserve_past?: string | null;
  prioridad: boolean;
  tipoServicio: ViajeTrasladoTipoServicio;
  fixedRate: RateModel['categories'][0]['fixedPrices'][0] | null;
  hasOutSite: boolean;
  bus_customer_price?: number;
  bus_provider_price?: number;
  bus_is_outsourced?: boolean;
  bus_observation?: string;
  bus_type_id?: number;
  bus_vehicle_id?: number;
  airport_details?: AirportDetails | null;
  event?: { id: number; name: string } | null;
}

function transferReservationSingleFormToModel(
  form: TransferReservationSingleFormType
): ViajeTrasladoCreateModelLegacyDontUse {
  return {
    ...transferReservationBaseFormBuilder.toModel(form),
    puntos: form.puntos.map(transferReservationBaseLocationFormBuilder.toModel),
    fechaYHoraDeLlegada: form.fechaYHoraDeLlegada,
    fechaYHoraDeSalida: form.minutosPreviosASalida,
    prioridad: form.prioridad,
    tipoServicio: form.tipoServicio,
    fixedRate: form.fixedRate,
    hasOutSite: form.hasOutSite,
    bus_requirement: form.tipoServicio === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES ? {
      bus_type_id: form?.bus_type_id ?? 0,
      vehicle_id: form?.bus_vehicle_id && form.bus_vehicle_id > 0
        ? form.bus_vehicle_id
        : null,
      provider_price: form?.bus_provider_price || 0,
      customer_price: form?.bus_customer_price || 0,
      is_outsourced: form?.bus_is_outsourced ? true : false,
      observation: form?.bus_observation ?? ''
    } : null,
    airport_details: form.airport_details,
    event_id: form.event?.id ?? null
  };
}

function transferReservationModelToSingleForm(
  reserva: ViajeTrasladoModelLegacyDontUse,
  cliente: ClientBusinessModel,
  fixedRate: RateModel['categories'][0]['fixedPrices'][0] | null
): TransferReservationSingleFormType {
  return {
    ...transferReservationBaseFormBuilder.toForm(reserva, cliente, fixedRate),
    puntos: reserva.puntos.map(
      transferReservationBaseLocationFormBuilder.toForm
    ),
    fechaYHoraDeLlegada: reserva.fechaYHoraDeLlegada,
    minutosPreviosASalida: reserva.fechaYHoraDeSalida,
    reason_reserve_past: reserva.reason_reserve_past ?? null,
    prioridad: reserva.prioridad,
    tipoServicio: reserva.tipoServicio as ViajeTrasladoTipoServicio,
    fixedRate: fixedRate,
    hasOutSite: reserva.hasOutSite,
    bus_customer_price: reserva?.bus_requirement?.customer_price || 0,
    bus_provider_price: reserva?.bus_requirement?.provider_price || 0,
    bus_is_outsourced: reserva?.bus_requirement?.is_outsourced || false,
    bus_observation: reserva?.bus_requirement?.observation || '',
    bus_type_id: reserva?.bus_requirement?.bus_type?.id || 0,
    bus_vehicle_id: reserva?.bus_requirement?.vehicle?.id || null,
    airport_details: reserva.airport_details,
    general_observation: reserva.general_observation ?? null,
    event: reserva.event ?? (reserva.event_id
      ? { id: reserva.event_id, name: reserva.event_name ?? '' }
      : null)
  };
}

export const transferReservationSingleFormBuilder = {
  toModel: transferReservationSingleFormToModel,
  toForm: transferReservationModelToSingleForm
};
